/*
 * @Author: lbh
 * @Date: 2021-12-15 10:07:00
 * @LastEditors: lbh
 * @LastEditTime: 2024-04-29 16:52:15
 * @Description: file content
 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  // 全局參數
  state: {
    // * 目前頁面已確認的品牌，啟動時不沿用可能過期的本地品牌
    brandId: "",
    // * 按頁面保存已確認品牌，避免切頁時沿用另一餐廳，並支援 keep-alive 返回
    brandRoute: "",
    brandIdsByRoute: {},
    isRefresh: false,
    isLogoutType: 1, // 1飯糰 , 2別府
    isAppInfo: "", //應用版本
    bfToken: "",
    isInit: false,
    hasLogin: false,
    showDiancan: null,
    brandLocation: JSON.parse(localStorage.getItem("brandLocation") || "{}"),
    // * 臨時登錄信息
    loginMsg: {
      phone: "",
      countryId: "",
    },
    // * 品牌信息
    brandInfo: {},
  },
  /**
   * set 方法
   * this.$store.commit('setDemoValue', value);
   */
  mutations: {
    // ? 同步頁面取得的有效品牌，供登入及協議響應式讀取
    setBrandId(state, brandId) {
      const value = String(brandId == null ? "" : brandId).trim();
      state.brandId = /^[1-9]\d*$/.test(value) ? value : "";
      if (state.brandRoute) Vue.set(state.brandIdsByRoute, state.brandRoute, state.brandId);
    },
    // ? 切換頁面時等待該頁品牌；返回已載入頁面時恢復其品牌
    activateBrandRoute(state, path) {
      state.brandRoute = path;
      state.brandId = state.brandIdsByRoute[path] || "";
    },
    setIsRefresh(state, isRefresh) {
      state.isRefresh = isRefresh;
    },
    setIsLogoutType(state, isLogoutType) {
      state.isLogoutType = isLogoutType;
    },
    setIsAppInfo(state, isAppInfo) {
      state.isAppInfo = isAppInfo;
    },
    setBfToken(state, bfToken) {
      state.bfToken = bfToken;
    },
    setIsInit(state, isInit) {
      state.isInit = isInit;
    },
    setHasLogin(state, hasLogin) {
      state.hasLogin = hasLogin;
    },
    setShowDiancan(state, showDiancan) {
      state.showDiancan = showDiancan;
    },
    setBrandLocation(state, location) {
      state.brandLocation = location;
      localStorage.setItem("brandLocation", JSON.stringify(location));
    },
    setLoginMsg(state, loginMsg) {
      state.loginMsg = loginMsg;
    },
    setBrandInfo(state, brandInfo) {
      state.brandInfo = brandInfo;
    },
  },
  /**
   * get 方法
   * this.$store.getters.getDemoValue
   */
  getters: {
    getBrandId: (state) => state.brandId,
    getIsRefresh: (state) => state.isRefresh,
    getIsLogoutType: (state) => state.isLogoutType,
    getIsAppInfo: (state) => state.isAppInfo,
    getBfToken: (state) => state.bfToken,
    getIsInit: (state) => state.isInit,
    getHasLogin: (state) => state.hasLogin,
    getShowDiancan: (state) => state.showDiancan,
    getBrandLocation: (state) => state.brandLocation,
    getLoginMsg: (state) => state.loginMsg,
    getBrandInfo: (state) => state.brandInfo,
  },
  actions: {},
  // 为了给全局变量分组，所以需要写提前声明其他store文件，然后引入这里
  modules: {},
});
